import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchClient } from "API/fetchClient";
import { ensureValidAccessToken } from "Utils/tokenManager";

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: number) => {
      if (!userId || isNaN(userId)) throw new Error("Invalid user ID provided");

      const hasValidToken = await ensureValidAccessToken();
      if (!hasValidToken) throw new Error("Authentication failed. Please log in again.");

      const response = await fetchClient(`/iam/users/${userId}/`, { method: "DELETE" });

      if (response.error) {
        const errorDetail = response.error.detail || response.error.message || "Unknown error";
        if (response.status === 401) throw new Error("Authentication failed. Please log in again.");
        if (response.status === 403)
          throw new Error("You don't have permission to delete this user.");
        throw new Error(`API Error: ${errorDetail}`);
      }

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
